export default __webpack_public_path__ + "static/media/img_background.629d11a3.png";